// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { licensePlateChangeCostApi } from '../../lib/api';
import { type LicensePlateChangeCost } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/license-plate-change-cost/';

export default (props: PageProps) => {
  const [data: LicensePlateChangeCost, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await licensePlateChangeCostApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: LicensePlateChangeCost) => {
    let id = payload.id;
    if (id) {
      await licensePlateChangeCostApi.update(payload);
    } else {
      let data = await licensePlateChangeCostApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: LicensePlateChangeCost) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость замены гос.номеров'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
